import { z } from "zod";
import { notificationTypeSchema } from "../_shared";

export const unacknowledgedPlatformNotificationsPerCompanyItemSchema = z.object(
  {
    uuid: z.uuid(),
    company: z.uuid(),
    type: notificationTypeSchema,
    title: z.string().nullable(),
    description: z.string().nullable(),
    actionPath: z.string().nullable(),
    createdAt: z.string(),
  },
);

export const unacknowledgedPlatformNotificationsPerCompanyResponseSchema =
  z.array(unacknowledgedPlatformNotificationsPerCompanyItemSchema);

export type UnacknowledgedPlatformNotificationsPerCompanyItem = z.infer<
  typeof unacknowledgedPlatformNotificationsPerCompanyItemSchema
>;
export type UnacknowledgedPlatformNotificationsPerCompanyResponse = z.infer<
  typeof unacknowledgedPlatformNotificationsPerCompanyResponseSchema
>;
